import { COMMUNITY_INFO_MODE } from 'constants/community';
import { canViewPricingData } from 'helpers/permissions';
import { UserType } from 'store/slices/authSlice';

export const splitAddress = (input: string): { street: string; restAddress: string } => {
  const index = input.indexOf(',');

  if (index === -1) {
    return { street: input, restAddress: '' };
  }

  return {
    street: input.substring(0, index).trim(),
    restAddress: input.substring(index + 1).trim(),
  };
};

export const canShowCommunityInfoPricingData = (currentUser: UserType | null, mode: number) => {
  return canViewPricingData(currentUser) || (mode === COMMUNITY_INFO_MODE.SYSTEM && Boolean(currentUser?.isSuperuser));
};
